import { Injectable } from '@angular/core';

import { PrestamosService } from '../../../../modules/finanzas/prestamos/prestamos.service';
import { PrestamosModel } from '../../../../modules/finanzas/prestamos/prestamos.model';
import { ensureOk } from '../../entity-form/entity-form.utils';

@Injectable({ providedIn: 'root' })
export class LoanEntityService {

  constructor(private prestamosService: PrestamosService) { }

  get(uid: string): Promise<PrestamosModel> {
    return this.prestamosService.get(uid).then(loan => {
      if (!loan) throw new Error();
      return loan;
    });
  }

  create(payload: PrestamosModel): Promise<void> {
    return this.prestamosService.add(payload).then(() => undefined);
  }

  update(uid: string, payload: PrestamosModel): Promise<void> {
    return this.prestamosService.edit({ ...payload, uid }).then(ensureOk);
  }
}
